(function () {
  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
    const modal = document.getElementById("docLightbox");
    if (!modal) return;

    const imgEl = modal.querySelector(".doc-lightbox__img");
    const closeEls = modal.querySelectorAll("[data-doc-close]");

    function openLightbox(src, alt) {
      imgEl.src = src;
      imgEl.alt = alt || "Image preview";
      modal.hidden = false;
      document.documentElement.style.overflow = "hidden";
    }

    function closeLightbox() {
      modal.hidden = true;
      imgEl.src = "";
      document.documentElement.style.overflow = "";
    }

    document.addEventListener("click", function (e) {
      const trigger = e.target.closest(".doc-zoom-trigger");
      if (trigger) {
        openLightbox(trigger.dataset.zoomSrc, trigger.dataset.zoomAlt);
        return;
      }

      if (e.target.closest("[data-doc-close]")) {
        closeLightbox();
      }
    });

    document.addEventListener("keydown", function (e) {
      if (!modal.hidden && e.key === "Escape") closeLightbox();
    });
  });
})();
